module.exports = __webpack_public_path__ + "img/004-005.868b1400.jpg";